import React from 'react';

const GiftBagIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 5.33268V3.99935C10 3.64573 9.85952 3.30659 9.60948 3.05654C9.35943 2.80649 9.02029 2.66602 8.66667 2.66602H7.33333C6.97971 2.66602 6.64057 2.80649 6.39052 3.05654C6.14048 3.30659 6 3.64573 6 3.99935V5.33268M10 5.33268H12.6667C13.0203 5.33268 13.3594 5.47316 13.6095 5.72321C13.8595 5.97326 14 6.31239 14 6.66602V11.9993C14 12.353 13.8595 12.6921 13.6095 12.9422C13.3594 13.1922 13.0203 13.3327 12.6667 13.3327H4.66667M10 5.33268H6M6 5.33268H4.66667M4.66667 13.3327H3.33333C2.97971 13.3327 2.64057 13.1922 2.39052 12.9422C2.14048 12.6921 2 12.353 2 11.9993V6.66602C2 6.31239 2.14048 5.97326 2.39052 5.72321C2.64057 5.47316 2.97971 5.33268 3.33333 5.33268H4.66667M4.66667 13.3327V5.33268M11.3333 5.33268V13.3327'
        stroke='#5B91F5'
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default GiftBagIcon;
